import React, { AnimationEventHandler } from "react";
import { FlatListItem } from "../../../components/partials/FlatList";
import { StartListEntry } from "../../../models/startlist.model";
import { Test } from "../../../models/test.model";
import { AnimatedFlatList } from "./components/AnimatedFlatList";
import { Flag } from "./components/Flag";
import { SquareList } from "./components/SquareList";
import { useIsBreeding } from "./hooks/useIsBreeding";
import { TeamColumn } from "./components/Column";

type CurrentGroupProps = {
  variant: "classic" | "square";
  group: StartListEntry[];
  test: Test;
};

export const CurrentGroup: React.FC<CurrentGroupProps> = ({
  variant,
  ...rest
}) => {
  switch (variant) {
    case "classic":
      return <CurrentGroupClassic {...rest} />;
    case "square":
      return <CurrentGroupSquare {...rest} />;
    default:
      return null;
  }
};

const CurrentGroupSquare: React.FC<Omit<CurrentGroupProps, "variant">> = ({
  group,
  test,
}) => {
  const isBreeding = useIsBreeding(test);

  return (
    <div className="square-container">
      {group.map((entry) => (
        <SquareList key={entry.id} style={{ gridArea: "unset" }}>
          <header>
            <div
              className="color"
              style={{
                backgroundColor: `var(--${
                  entry.color !== "" ? entry.color : "blue"
                })`,
              }}
            ></div>
            <div>
              {isBreeding ? entry.horse?.horseName : entry.rider?.fullname}
            </div>
            {entry.rider?.team !== "" && (
              <TeamColumn
                team={entry.rider?.team ?? ""}
                style={{ marginLeft: "auto" }}
                showCountryCode={false}
              />
            )}
          </header>
        </SquareList>
      ))}
    </div>
  );
};

const GroupInfo: React.FC<FlatListItem<StartListEntry, Test>> = ({
  item,
  onHidden,
  show,
}) => {
  const hide: AnimationEventHandler<HTMLDivElement> = (event) => {
    if (event.animationName === "scaleOut") {
      onHidden?.();
    }
  };

  return (
    <div
      className={`flatlist-item ${show ? "show" : "hide"}`}
      onAnimationEnd={hide}
    >
      <div
        className="row-content"
        style={{ gridTemplateColumns: "1fr min-content" }}
      >
        <div
          className="row-marker"
          style={{ backgroundColor: `var(--${item.color})` }}
        ></div>
        <div>{item.rider?.fullname}</div>
        <Flag countryCode={item.rider?.team ?? ""} style={{ height: "1em" }} />
      </div>
    </div>
  );
};

const CurrentGroupClassic: React.FC<Omit<CurrentGroupProps, "variant">> = ({
  group,
}) => {
  return (
    <>
      <AnimatedFlatList
        items={group}
        RenderComponent={GroupInfo}
        itemsPerPage={6}
        usePlaceholder={false}
      />
    </>
  );
};
